import { useEffect, useRef } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'

import Loading from 'modules/core/components/Loading'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

import { useCreateSurvey } from 'modules/engagement_surveys/hooks/useCreateSurvey'

export default function NewSurveyPage() {
  const navigate = useNavigate()
  const { navigation } = useNavigation()
  const [searchParams] = useSearchParams()
  const templateFormId = searchParams.get('templateId') ?? undefined
  const creating = useRef(false)
  const createSurvey = useCreateSurvey()

  useEffect(() => {
    if (creating.current) return
    creating.current = true

    const create = async () => {
      const surveyId = await createSurvey({ templateFormId })

      if (surveyId) {
        navigate(
          navigation.engagement.smart_surveys.survey.questions.fullPath({
            surveyId,
          }),
          { replace: true }
        )
      } else {
        app.setFlash({
          type: 'wrong',
          message: i18n.t('common.error'),
        })
        navigate(navigation.engagement.smart_surveys.overview.fullPath(), {
          replace: true,
        })
      }
    }

    create()
  }, [createSurvey, navigate, navigation, templateFormId])

  return <Loading expand />
}
